import React from 'react'

export function ReturnIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      fill="none"
      viewBox="0 0 48 48"
    >
      <circle cx="24" cy="24" r="24" fill="#364153" />
      <path
        fill="#C3CEDC"
        fillRule="evenodd"
        d="M17.25 23.996a.75.75 0 01.75-.75h12a.75.75 0 010 1.5H18a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill="#C3CEDC"
        fillRule="evenodd"
        d="M24.53 17.47a.75.75 0 010 1.06L19.06 24l5.47 5.47a.75.75 0 11-1.06 1.06l-6-6a.75.75 0 010-1.06l6-6a.75.75 0 011.06 0z"
        clipRule="evenodd"
      />
    </svg>
  )
}
